<template>
  <v-text-field
    outlined
    label="Keywords"
    v-model="keywords"
    messages="Separa le keywords con la virgola, esempio: cane, animali domestici, gatto"
  ></v-text-field>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'SeoKeywords',
    data() {
      return {
        keywords: '',
      }
    },
    computed: {
      ...mapGetters([
        'newArticle'
      ])
    },
    watch: {
      keywords(val) {
        this.$store.commit('SET_ARTICLE_KEYWORDS', val)
      },
      newArticle: {
        handler(val) {
          this.keywords = val.keywords
        },
        deep: true
      }
    },
    created() {
      this.keywords = this.newArticle.keywords
    }
  }
</script>